<template>
  <my-giving-layout :enable-scroll-event="true">
    <main v-if="isLoading">
      <div class="w-full h-full min-h-screen bg-[#F6F4F0] relative">
        <LoadingState />
      </div>
    </main>
    <div v-else class="pb-[64px]">
      <!-- Header with back button -->
      <BackButton class="w-full px-[20px] mb-[16px]" :customBack="back" />
      <div class="p-[20px] md:p-[24px] lg:p-[28px]">
        <!-- Page Title -->
        <h4
          class="text-[2rem] md:text-[3rem] lg:text-[3.25rem] leading-[2.5rem] md:leading-[3.5rem] lg:leading-[4rem] font-[900] text-[#433D31]"
        >
          Add Bank Account
        </h4>
        <div
          class="text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] leading-[1.5rem] md:leading-[2.25rem] lg:leading-[2.5rem] text-[#433D31] mt-[8px]"
        >
          Select a bank
        </div>

        <!-- Load failure. Previously this state rendered nothing at all: an
             empty "Select a bank" screen with no error and no way back in. -->
        <div
          v-if="loadError && !banks.length"
          class="mt-[32px] p-[16px] border-[1px] border-solid border-[#EC4E20] rounded-[10px]"
        >
          <p class="text-[1rem] leading-[1.5rem] text-[#433D31]">
            We couldn't load the list of banks. {{ loadError }}
          </p>
          <button
            type="button"
            class="mt-[16px] w-full py-[12px] rounded-[100px] border-solid border-[2px] border-[#42362B] text-[1rem] font-[700] text-[#21201E]"
            @click="getBankList"
          >
            Try again
          </button>
        </div>

        <!-- Banks List -->
        <div class="flex flex-col gap-[12px] mt-[32px]">
          <button
            v-for="bank in banks"
            :key="bank.code"
            @click="selectBank(bank.code)"
            class="w-full p-[16px] border-[#A5A4A3] border-[1px] border-solid rounded-[10px] text-[1rem] md:text-[1.75rem] lg:text-[1.875rem] font-[500] text-gray-900 text-left flex items-center justify-between h-[56px] md:h-[72px] lg:h-[80px]"
          >
            <div class="flex items-center">
              <img
                :src="bank.iconPath"
                :alt="bank.name"
                class="bank-icon mr-[12px] w-[24px] h-[24px]"
              />
              {{ bank.name }}
            </div>
            <img
              src="/assets/icons/my-giving/chevronRight.svg"
              alt="Arrow Right"
              class="w-[16px] h-[16px] fill"
            />
          </button>
        </div>
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import BackButton from '@/components/common/BackButton.vue';
import axios from 'axios';
import { BANK_LIST } from '../../constants/MyGiving/bank-list';
import MyGivingLayout from '@/components/MyGivingLayout.vue';
import LoadingState from '@/components/common/LoadingState.vue';

export default {
  name: 'ListOfBanks',
  components: {
    BackButton,
    MyGivingLayout,
    LoadingState,
  },
  data() {
    return {
      banks: [],
      isLoading: true,
      loadError: '',

      // banks: [
      //   {
      //     bankCode: "BKCHSGSGXXX",
      //     bankName: "Bank of China Limited",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "BKCHSGSGXXX",
      //     bankName: "Bank of China Limited",
      //     segment: "Corporate",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "CITISGSLXXX",
      //     bankName: "Citibank Singapore Limited",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "DBSSSGSGXXX",
      //     bankName: "DBS Bank Ltd",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "DBSSSGSGXXX",
      //     bankName: "DBS Bank Ltd",
      //     segment: "Corporate",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "HSBCSGS2XXX",
      //     bankName: "HSBC Bank (Singapore) Ltd",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "ICBKSGSGXXX",
      //     bankName: "Industrial & Commercial Bank Of China",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "ICBKSGSGXXX",
      //     bankName: "Industrial & Commercial Bank Of China",
      //     segment: "Corporate",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "SSPISGSGXXX",
      //     bankName: "MariBank Singapore Private Limited",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "SSPISGSGXXX",
      //     bankName: "MariBank Singapore Private Limited",
      //     segment: "Corporate",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "MBBESGS2XXX",
      //     bankName: "Maybank Singapore Limited",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "MBBESGS2XXX",
      //     bankName: "Maybank Singapore Limited",
      //     segment: "Corporate",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "OCBCSGSGXXX",
      //     bankName: "Oversea-Chinese Banking Corporation Ltd",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "OCBCSGSGXXX",
      //     bankName: "Oversea-Chinese Banking Corporation Ltd",
      //     segment: "Corporate",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "SCBLSG22XXX",
      //     bankName: "Standard Chartered Bank, (Singapore) Limited",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "UOVBSGSGXXX",
      //     bankName: "United Overseas Bank Ltd",
      //     segment: "Retail",
      //     status: "Online",
      //   },
      //   {
      //     bankCode: "UOVBSGSGXXX",
      //     bankName: "United Overseas Bank Ltd",
      //     segment: "Corporate",
      //     status: "Online",
      //   },
      // ],
    };
  },
  methods: {
    back() {
      this.$router.push('/my-giving/manage#accounts');
    },
    selectBank(applicantBankCode) {
      const query = {};
      if (this.$route.query.fromrecurring === 'true' || this.$route.query.fromrecurring === true) {
        query.fromrecurring = true;
      }
      this.$router.push({
        path: `/my-giving/link-bank/${applicantBankCode}`,
        query,
      });
    },
    async getBankList() {
      try {
        this.isLoading = true;
        const response = await axios.get(
          `${process.env.VUE_APP_GIVING_API_V2_URL}/e-giro/list-banks`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
          },
        );
        // Get all valid bank codes from BANK_LIST
        const validBankCodes = BANK_LIST.map(bank => bank.code);
        // Filter API response to only include banks with matching bankCode
        const filteredBanks = response.data
          .filter(apiBank => validBankCodes.includes(apiBank.bankCode))
          .map(apiBank => {
            // Find the matching bank from BANK_LIST to get name/iconPath/etc.
            const matchedBank = BANK_LIST.find(bank => bank.code === apiBank.bankCode);
            return matchedBank ? matchedBank : null;
          })
          .filter(Boolean);
        this.banks = filteredBanks;
        this.loadError = '';
        this.isLoading = false;
      } catch (error) {
        // The message used to be built and then dropped on the floor, so a
        // failed fetch left an empty "Select a bank" screen with no error and
        // no retry — at the very top of the linking funnel (ONE-8185).
        this.loadError =
          error.response?.data?.message || error.message || 'Failed to process bank response.';
        this.$store.dispatch('toast/error', this.loadError);
        this.isLoading = false;
      }
    },
  },
  async ionViewWillEnter() {
    await this.getBankList();
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter';
}
</style>
